import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router';

import useStoreTranslation from 'hooks/useStoreTranslation';

import DesktopProfileMenu from '../DesktopProfileMenu';
import { Container, IconProfile, IconHelp, Icon } from './styles';

interface Props {
  name: string;
  email: string;
  companyName: string;
  companyCountry: string;
  companyCountryCode: string;
  hasCompanyBranches: boolean;
  branchCompanyLogged: boolean;
}

const RequesterProfile = ({
  name,
  email,
  companyName,
  companyCountry,
  companyCountryCode,
  hasCompanyBranches,
  branchCompanyLogged,
}: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();
  const initialsRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const handleMenuToggle = () => setOpen(!open);

  const handleCountrySelection = () => {
    history.push('/user-country-selection');
  };

  const handleCountryFlag = (branchCompany: string) => {
    switch (branchCompany) {
      case 'BR': {
        return 'images/flags/BR.png';
      }
      case 'CO': {
        return 'images/flags/CO.png';
      }
      case 'AR': {
        return 'images/flags/AR.png';
      }
      case 'UY': {
        return 'images/flags/UY.png';
      }
      case 'MX': {
        return 'images/flags/MX.png';
      }
    }

    return 'images/flags/CO.png';
  };

  return (
    <Container>
      {hasCompanyBranches && hasCompanyBranches === true && (
        <Icon.Flag onClick={handleCountrySelection}>
          <img alt="" src={handleCountryFlag(companyCountryCode)} />
        </Icon.Flag>
      )}
      <Icon onClick={handleMenuToggle}>
        <IconProfile />
        <Icon.Label>{t('dashboard.menu.profile')}</Icon.Label>
      </Icon>
      <DesktopProfileMenu
        open={open}
        onToggle={handleMenuToggle}
        initialsRef={initialsRef}
        name={name}
        email={email}
        companyName={companyName}
        countryName={companyCountry}
        branchCompanyLogged={branchCompanyLogged}
        hasCompanyBranches={hasCompanyBranches}
        countryCode={companyCountryCode}
      />
      <Icon onClick={() => history.push('/customerSupport')}>
        <IconHelp />
        <Icon.Label>{t('dashboard.menu.help')}</Icon.Label>
      </Icon>
    </Container>
  );
};

export default RequesterProfile;
